import React, {useCallback, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import SendIcon from '@material-ui/icons/Send';
import {SizeMe} from "react-sizeme";
import IconButton from "@material-ui/core/IconButton";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {CREATE_NOTE, DELETE_NOTE, GET_NOTES_OF_PARENT} from "../../database/queries/noteQueries";
import {notify} from "../../utils/notify";
import CalendarStrings from "../../constants/calendarStrings";
import Moment from "react-moment";
import useLayoutStore from "../../layoutStore";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {useParams} from "react-router-dom";
import ItemMenu from "./itemMenu";

const inIFrame = (window.parent.window !== window);

const useStyles = makeStyles(theme => ({
    chatSection: {
        overflow: 'auto',
        marginBottom: 10,
    },
    messageArea: {
        // height: '70vh',
        overflowY: 'auto'
    },
    newMessage: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
        verticalAlign: 'middle'
    },
    newMessageIFrame: {
        paddingLeft: 8,
        paddingRight: 8,
        paddingBottom: 8,
        verticalAlign: 'middle'
    },
    fixButton: {
        textAlign: 'right',
        paddingTop: 12,
    },
    messagePaper: {
        maxWidth: 400,
        // margin: `${theme.spacing(1)}px auto`,
        paddingLeft: theme.spacing(1),
        verticalAlign: 'middle',
        display: 'inline-flex'
    },
    listRight: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    wrapIcon: {
        verticalAlign: 'middle',
        display: 'inline-flex'
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
}));

const ChatNotes = (props) => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();
    const [newNote, setNewNote] = useState('');
    let {shareCategoryType, shareCategoryId} = useParams();

    const {loading: getNotesOfParentLoading, error: getNotesOfParentError, data: getNotesOfParentData, refetch: getNotesOfParentRefetch} = useQuery(GET_NOTES_OF_PARENT, {
        // skip: !props.shareObj || !props.parentObj,
        variables: {
            parentType: props.editType ? props.editType : 'general',
            parentId: props.editId ? props.editId : 'general',
            shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
            shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
            orderList: ['updatedAt ASC']
        },
    });

    const [createNote, {error: createNoteError}] = useMutation(CREATE_NOTE);
    const [deleteNote, {error: deleteNoteError}] = useMutation(DELETE_NOTE);

    useEffect(() => {
        if (createNoteError) notify('createNoteError', 'error', createNoteError.message);
        if (deleteNoteError) notify('deleteNoteError', 'error', deleteNoteError.message);
        if (getNotesOfParentError) notify('getNotesOfParentError', 'error', getNotesOfParentError.message);
    }, [createNoteError, deleteNoteError, getNotesOfParentError]);

    useEffect(() => {
        getNotesOfParentRefetch();
    }, [getNotesOfParentRefetch]);

    useEffect(() => {
    }, [globalLayoutState.tabBarHeight]);

    useEffect(() => {
        if (getNotesOfParentData && getNotesOfParentData.notesOfParent) {
            const elem = document.getElementById("scrollArea");
            if (elem) elem.scrollTop = elem.scrollHeight;
        }
    }, [getNotesOfParentData]);

    useEffect(() => {
    }, [getNotesOfParentData]);

    const scrollAreaCallback = useCallback(node => {
        if (node !== null) {
            node.scrollTop = node.scrollHeight;
        }
    }, []);

    const handleChange = (e) => {
        setNewNote(e.target.value);
    };

    const handleSaveNote = (e) => {
        createNote({
            variables: {
                newNote: {
                    parentType: props.editType ? props.editType : 'general',
                    parentId: props.editId ? props.editId : 'general',
                    shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
                    shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
                    note: newNote,
                }
            }
        }).then(function (createResult) {
            setNewNote('');
            getNotesOfParentRefetch();
        }).catch((e) => notify('createNoteError', 'error', 'problem saving note: ' + e.message))
    };

    if (getNotesOfParentLoading) return <p>Loading ...</p>;
    if (getNotesOfParentError) return `Error! ${getNotesOfParentError.message}`;

    return (
        <div>
            <SizeMe>
                {({size}) => {
                    let height = size.height;
                    if (!height) height = window.innerHeight;
                    let otherStuffHeight = 240;
                    if (inIFrame) otherStuffHeight = 160;
                    const newMessageAreaHeight = height - (globalLayoutState.headerHeight + globalLayoutState.tabBarHeight + otherStuffHeight);
                    return (
                        <div>
                            <AppBar color={props.color ? props.color : 'default'} position="static"
                                    className={classes.noMargin}>
                                <Toolbar className={classes.noMargin}>
                                    <Typography
                                        variant="h6"
                                        color="inherit"
                                        className={classes.title}
                                    >
                                        {props.shareCategoryName ? props.shareCategoryName + ' ' : ''}Notes
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <Grid container ref={scrollAreaCallback} id="scrollArea" component={Paper}
                                  className={classes.chatSection}
                                  style={{height: newMessageAreaHeight}}>
                                {getNotesOfParentData && getNotesOfParentData.notesOfParent && (
                                    <Grid item xs={12}>
                                        <List className={classes.messageArea}>
                                            {getNotesOfParentData.notesOfParent.map(note => {
                                                return (
                                                    <ListItem key={note.noteId} className={classes.listRight}
                                                              dense={true}>
                                                        <Grid container>
                                                            <Grid item xs={12} style={{textAlign: 'right'}}>
                                                                <Paper className={classes.messagePaper} align="right"
                                                                       color={"default"}>
                                                                    <Typography variant="body2"
                                                                                className={classes.wrapIcon}>
                                                                        {note.note}
                                                                        <ItemMenu
                                                                            itemId={note.noteId}
                                                                            itemDelete={deleteNote}
                                                                            itemsRefetch={getNotesOfParentRefetch}
                                                                        />
                                                                    </Typography>
                                                                </Paper>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography variant="body2"
                                                                            align="right"
                                                                            className={classes.wrapIcon}
                                                                            style={{fontSize: '60%', paddingRight: 8}}>
                                                                    <Moment
                                                                        calendar={CalendarStrings}>{note.updatedAt}
                                                                    </Moment>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                )
                                            })}
                                        </List>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    )
                }}
            </SizeMe>
            <Divider/>
            <Grid container className={inIFrame ? classes.newMessageIFrame : classes.newMessage}
                  component={Paper}>
                <Grid item xs={11}>
                    <TextField
                        id="outlined"
                        size="small"
                        label="New note"
                        value={newNote}
                        onChange={handleChange}
                        onKeyUp={(event) => {
                            if (event.key === 'Enter' || event.key === 'Return') handleSaveNote(event);
                        }}
                        fullWidth/>
                </Grid>
                <Grid item xs={1} className={classes.fixButton}>
                    <IconButton
                        aria-label="save note"
                        color="inherit"
                        variant="contained"
                        size="small"
                        disabled={!newNote || newNote.length === 0}
                        onClick={handleSaveNote}
                    >
                        <SendIcon/>
                    </IconButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default ChatNotes;
